module.exports = "pegasus_template/assets/circle-pinterest.png";